import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import {
    getFestivitiesTableAPI,
    setFestivitiesTableAPI,
    deleteFestivitiesTableAPI
} from "@icarius-connection/api";

export const getFestivitiesTableFromServer = () => async (dispatch) => {
    dispatch({ type: actionTypes.GET_ROWS });
    try {
        let response = await getFestivitiesTableAPI();
        let rows = response.data && response.data.data;
        let tableTypes = response.data && response.data.tableTypes;

        dispatch({
            type: actionTypes.GET_ROWS_FULFILLED,
            payload: { rows, tableTypes },
        });
        return response;
    } catch (e) {
        dispatch({ type: actionTypes.GET_ROWS_REJECTED, payload: e });
        dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
};

export const setFestivitiesTableToServer = (data) => async (dispatch) => {
    dispatch({ type: actionTypes.SET_ROWS });
    try {
        let response = await setFestivitiesTableAPI({ data });
        let rows = response.data && response.data.data;

        dispatch({
            type: actionTypes.SET_ROWS_FULFILLED,
            payload: { rows },
        });
        dispatch(openSnackbarAction({ msg: getLocalizedString("valuesUpdatedSuccessfully"), severity: "success" }));
        return response;
    } catch (e) {
        dispatch({ type: actionTypes.SET_ROWS_REJECTED, payload: e });
        if (e.response.data.status === 'DUPLICATED_DATA') {
            dispatch(openSnackbarAction({ msg: getLocalizedString("cannotExistValuesWithSameTypeStartDateAndEndDate"), severity: "error" }));
            return e;
        }
        dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
};

export const deleteFestivitiesTableInServer = (codes) => async (dispatch) => {
    dispatch({ type: actionTypes.DELETE_ROWS });
    try {
        let response = await deleteFestivitiesTableAPI({ codes });
        let rows = response.data && response.data.data;

        dispatch({
            type: actionTypes.DELETE_ROWS_FULFILLED,
            payload: { rows },
        });

        return response;
    } catch (e) {
        dispatch({ type: actionTypes.DELETE_ROWS_REJECTED, payload: e });
        dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
};